import React from 'react';
import styles from './PromptPanel.module.css';
import { type Instruction } from '../AssistantView/AssistantViewController';
import { ApplicationView } from '@aha-app/mvc';
import classNames from 'classnames';

const DefaultScopeItem = ApplicationView(
  ({
    content,
    onRemove,
    className,
  }: {
    content: string | React.ReactNode;
    onRemove?: () => void;
    className?: string;
  }) => {
    if (!content) return null;

    return (
      <div className={classNames(styles.scopeItem, className)}>
        <div className={styles.scopeItemText}>{content}</div>
        {onRemove && <i className='fa fa-xmark' onClick={onRemove} />}
      </div>
    );
  }
);

const SelectionScopeItem = ApplicationView(
  ({ content }: { content: string }) => {
    return (
      <DefaultScopeItem
        content={content}
        className={styles.scopeItemSelection}
      />
    );
  }
);

const InstructionScopeItem = ApplicationView(
  ({
    instructions,
    onRemove,
  }: {
    instructions: Array<Instruction>;
    onRemove: (i: Instruction) => void;
  }) => {
    if (!instructions || instructions.length === 0) return null;

    return instructions.map(instruction => (
      <DefaultScopeItem
        content={instruction.name}
        onRemove={() => onRemove(instruction)}
      />
    ));
  }
);

const ReferenceScopeItem = ApplicationView(
  ({
    referenceNum,
    onRemove,
  }: {
    referenceNum: string;
    onRemove?: () => void;
  }) => {
    if (!referenceNum) return null;

    let name = referenceNum;

    if (referenceNum.startsWith('Report-')) {
      const reportName = document
        .querySelector('.report-header h1')
        ?.textContent?.trim();
      if (reportName) {
        name = reportName;
      }
    }

    return (
      <DefaultScopeItem
        content={
          <>
            <aha-record-icon reference-num={referenceNum} /> {name}
          </>
        }
        onRemove={onRemove}
      />
    );
  }
);

export {
  DefaultScopeItem,
  SelectionScopeItem,
  InstructionScopeItem,
  ReferenceScopeItem,
};
